import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import makeStyles from "@mui/styles/makeStyles";

const buttonStyle = makeStyles(theme => ({
    button: {
        minWidth: "max-content",
        color: theme.palette.mode === "light" ? "#000000" : "#FFFFFF",
        fontWeight: 400,
        fontSize: 12,
        fontFamily: "Inter",
        borderRadius: 8,
        backgroundColor: theme.palette.background.paper,
        display: "flex",
        textTransform: "none",
        "&:hover": {
            backgroundColor: theme.palette.mode === "light" ? "#a4a4a4" : "#FFFFFF",
            color: theme.palette.mode === "light" ? "#000000" : "#000000",
            borderColor: theme.palette.mode === "light" ? "#a4a4a4" : "#FFFFFF",
            boxShadow: "none",
        },
    },
    font: {
        fontFamily: "Inter",
        fontWeight: 500,
        fontSize: 12,
    },
}));

const AgyleTextFieldButton = (props) => {
    const classes = buttonStyle();
    return (
        <Button
            className={classes.button}
            onClick={props.onClick}
            startIcon={props.startIcon}
            size="small"
            disableTouchRipple
            disabled={props.disabled}
        >
            <div className={classes.font}>
                {props.label}
            </div>
        </Button>
    );
};

export default AgyleTextFieldButton;

AgyleTextFieldButton.propTypes = {
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    startIcon: PropTypes.object,
    disabled: PropTypes.bool,
};

AgyleTextFieldButton.defaultProps = {
    name: "",
    disabled: false,
};